import { IconCalendarToday } from "../icon/variants/IconCalendarToday.js";
import date_picker_module_default from "./date-picker.module.js";
import { jsx } from "react/jsx-runtime";
import "@mantine/dates/styles.css";
import { YearPickerInput } from "@mantine/dates";

//#region src/components/date-picker/YearPickerInput.tsx
const YearPickerInput$1 = ({ label, placeholder, value, required, error, disabled, onChange, maxDate, minDate, "data-testid": testId }) => {
	const hasValue = value?.toString().trim().length !== 0;
	return /* @__PURE__ */ jsx(YearPickerInput, {
		label,
		placeholder,
		value,
		onChange,
		required,
		labelProps: { "data-floating": hasValue },
		radius: "xxs",
		size: "xl",
		classNames: date_picker_module_default,
		descriptionProps: { className: disabled ? date_picker_module_default.descriptionDisabled : date_picker_module_default.description },
		inputWrapperOrder: error ? [
			"label",
			"input",
			"error"
		] : [
			"label",
			"input",
			"description"
		],
		rightSection: /* @__PURE__ */ jsx(IconCalendarToday, { style: { marginRight: "var(--mantine-spacing-sm)" } }),
		rightSectionPointerEvents: "none",
		maxDate,
		minDate,
		"data-testid": testId
	});
};

//#endregion
export { YearPickerInput$1 as YearPickerInput };